import store from '@/store';

export const errorNotification = (message) => {
  store.dispatch(
    'auth/new_notification',
    {
      type: 'notification',
      message: message,
      error: true,
    },
    { root: true }
  );
};

export const succussNotification = (message) => {
  store.dispatch(
    'auth/new_notification',
    {
      type: 'notification',
      message: message,
    },
    { root: true }
  );
};
